export default (response: Response) => {
  if (response.status >= 200 && response.status < 300) {
    return response.json()
  }

  throw response
}



// WEBPACK FOOTER //
// ./src/utils/fail-on-http-error.ts